<template>
	<div>
		<b-navbar
			class="fixed-top"
			ref="navbar"
			:class="{ sticky: isScroll }"
			toggleable="lg"
			type="light"
		>
			<img
				@click="handleLink('Home')"
				:src="logoSrc"
				alt="Catsitter Indonesia logo"
				role="button"
			/>

			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse
				id="nav-collapse"
				is-nav
			>
				<b-navbar-nav>
					<b-nav-item
						role="button"
						@click="handleLink('Services')"
						:aria-label="servicesLabel"
					>
						{{ servicesLabel }}
					</b-nav-item>
					<b-nav-item
						role="button"
						@click="handleLink('Profile')"
						:aria-label="profileLabel"
					>
						{{ profileLabel }}
					</b-nav-item>
					<b-nav-item
						role="button"
						@click="handleLink('Blog')"
						aria-label="Open Blog"
						>Blog</b-nav-item
					>
					<b-nav-item
						role="button"
						@click="handleLink('Career')"
						:aria-label="careerLabel"
					>
						{{ careerLabel }}
					</b-nav-item>
				</b-navbar-nav>

				<b-navbar-nav class="ms-auto align-items-center">
					<div class="lang justify-content-center align-items-center d-flex">
						<p class="mb-0">ID</p>
						<b-form-checkbox
							v-model="isLangActive"
							switch
							@change="handleLangOnChange"
							class="mx-2"
						></b-form-checkbox>
						<p class="mb-0">EN</p>
					</div>
					<b-button
						@click="handleLink('Contact')"
						class="btn-contact ms-lg-3 mt-4 mt-lg-0"
						:aria-label="contactLabel + ' via WhatsApp'"
					>
						{{ contactLabel }}
					</b-button>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
	</div>
</template>

<script>
const LOGO_DEFAULT = "https://catsitterindonesia.com/image/logo.7e9d97f2.png";
const LOGO_ORANGE =
	"https://catsitterindonesia.com/image/logoorange.75f6438e.png";
const BLOG_URL = "https://blog.catsitterindonesia.com/";
const LANG_KEY = "lang";

const LINK_RESOLVERS = Object.freeze({
	Blog: () => BLOG_URL,
	Contact: (vm) => vm.getLinkByType("whatsapp")?.url,
	Career: (vm) => vm.getLinkByType("career")?.url,
});

export default {
	name: "NavbarComponent",
	emits: ["trigger-services", "trigger-lang"],
	props: {
		links: {
			type: Array,
			default: () => [],
			validator: (arr) =>
				Array.isArray(arr) &&
				arr.every(
					(it) =>
						it &&
						typeof it === "object" &&
						typeof it.type === "string" &&
						typeof it.url === "string"
				),
		},
	},
	data() {
		return {
			isScroll: false,
			lang: localStorage.getItem(LANG_KEY) || "en",
			isLangActive: false,
		};
	},
	mounted() {
		this.syncLangState();
		window.addEventListener("scroll", this.handleScroll, { passive: true });
	},
	beforeUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	computed: {
		isIdLang() {
			return this.lang === "id";
		},
		servicesLabel() {
			return this.isIdLang ? "Layanan" : "Services";
		},
		profileLabel() {
			return this.isIdLang ? "Profil Cat Sitter" : "Cat Sitter Profile";
		},
		careerLabel() {
			return this.isIdLang ? "Karir" : "Career";
		},
		contactLabel() {
			return this.isIdLang ? "Hubungi Kami" : "Contact Us";
		},
		logoSrc() {
			return this.isScroll ? LOGO_ORANGE : LOGO_DEFAULT;
		},
	},
	methods: {
		handleScroll() {
			this.isScroll = window.scrollY > 0;
		},
		getLinkByType(name) {
			return this.links.find((item) => item.name === name);
		},
		openSafe(url) {
			if (url) {
				window.open(url, "_blank", "noopener,noreferrer");
			}
		},
		handleLink(source) {
			this.closeNavbar();
			const resolver = LINK_RESOLVERS[source];
			if (resolver) {
				return this.openSafe(resolver(this));
			}
			if (source === "Services") {
				if (this.$route.name !== "Home") {
					this.$router.push({ name: "Home" });
				}

				return this.$emit("trigger-services");
			}
			return this.$router.push({ name: source });
		},
		syncLangState() {
			const saved = localStorage.getItem(LANG_KEY);
			if (saved) this.lang = saved;
			localStorage.setItem(LANG_KEY, this.lang);
			this.isLangActive = this.lang === "en";
		},
		handleLangOnChange() {
			this.closeNavbar();
			this.lang = this.isLangActive ? "en" : "id";
			localStorage.setItem(LANG_KEY, this.lang);
			this.$emit("trigger-lang", this.lang);
		},
		closeNavbar() {
			if (window.innerWidth > 992) {
				return;
			}
			const toggler = this.$el.querySelector(".navbar-toggler");
			if (toggler) toggler.click();
		},
	},
};
</script>

<style scoped>
nav.sticky {
	background: #fff;
}

nav .btn-contact {
	padding: 0.63vw 1.25vw;
	background: #fdb23f;
	color: #fff;
	font-weight: 600;
	font-size: 1.25vw;
	border: 0;
	border-radius: 2.5vw;
}

nav .btn-contact:hover,
nav .btn-contact:active {
	background: #fff;
	color: #ff5a2a;
}

nav.sticky .btn-contact {
	background: linear-gradient(90deg, #ff5a2a, #fdb23f);
	animation-direction: reverse;
}

nav.sticky .btn-contact:hover {
	background: linear-gradient(90deg, #ff5a2a, #ff5a2a) !important;
	color: #fff !important;
}

nav .lang p {
	font-size: 1.25vw;
	color: #fff;
}

nav.sticky .lang p {
	font-size: 1.25vw;
	color: #ff5a2a;
}

/* mobile */
@media (max-width: 991.98px) {
	nav .btn-contact,
	nav.sticky .btn-contact {
		padding: 3vw 9vw;
		background: #fdb23f;
		color: #f8eee2;
		font-weight: 600;
		font-size: 4vw;
		border: 0;
		text-align: center;
		border-radius: 10vw;
	}

	nav .lang p,
	nav.sticky .lang p {
		font-size: 4vw;
	}
}
</style>
